// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

export const OpenReport = (props: IconType) => {
  const { size, inverse, onClick, width, height, stroke, iconClassName } = props;

  const defaultMeasurements: Measurements = {
    height: 18,
    width: 18,
  };

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-open-report">
      <svg
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1636_8397)">
          <path
            d="M4 21V17C4 16.2044 4.31607 15.4413 4.87868 14.8787C5.44129 14.3161 6.20435 14 7 14H12"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M9 17L12 14L9 11" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 11V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7.5"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1636_8397">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
